module.exports = __webpack_public_path__ + "img/FixedTime.2b38d853.svg";